export default "__VITE_ASSET__Bors2qVZ__"